<template>
  <div class="marginator">
    <div class="mt-4">
      
      <div v-if="items.length == 0" class="nodata">
        <span class="text-grey" size="50px" color="#808F9C">no closed trades</span>
      </div>

      <transition-group name="list">
        <div class="record-card" v-for="record in items.slice(0,showCount)" :key="record._id">
          <trade :record="record"></trade>
        </div>
      </transition-group>

      <div v-if="items.length > 5" class="width-full float-left mt-2 pr-2">
        <div
        v-scroll-to="{el: '#results-row',offset: -200}"
          @click="showMore = true"
          class="more text-right"
          v-if="!showMore"
        >{{"Show All ("+items.length+")"}}</div>
        <div
         v-scroll-to="{el: '#results-row',offset: -50}"
          @click="showMore = false"
          class="more text-right"
          v-if="showMore"
        >Hide</div>
      </div>

    </div>
      

    <div class="results-card">
      <div class="result-card">
        <div class="result-head">
          Closed trades:
          <span id="result-trades" class="text-white bold">{{openTrades}}</span> | Volume:
          <span id="result-pcs" class="text-white bold">{{volume}} pcs</span>
        </div>
        <div class="result-pl">
          Open P/L:
          <span
            class="bold size-mid"
            v-bind:class="openPl > 0 ? 'profit' : 'loss'"
          >$ {{openPl.toFixed(2)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import trade from "./item.vue";
import axios from "axios";

export default {
  name: "OpenTrades",
  components: {
    trade
  },
  data() {
    return {
      showMore: false,
      showCount: 5,
      items: [],
      loaded: false,
      openTrades: 0,
      users: 0,
      volume: 0,
      openPl: 0
    };
  },
watch: {
    showMore(newVal) {
      if (newVal) {
        this.showCount = 999999;
      } else {
        this.showCount = 5;
      }
    }
  },
  computed: {},
  mounted() {
    this.getHistory();
  },
  methods: {

    getHistory() {
      this.$emit("loading", true);
      axios
        .post("https://tradeinpool.com:3001/api/request/results/", {
          method: "daily"
        })
        .then(response => {
          this.items = response.data;
          this.loaded = true;
          this.statCalculate();
          this.$emit("loading", false);
        });
    },
    statCalculate() {
      this.sortData()
      this.openPl = 0;
      this.volume = 0;
      this.openTrades = 0;
      this.items.forEach(trade => {
        this.openPl += trade.pl;
        this.volume += trade.lots;
        this.openTrades += trade.trades;
      });
      this.users = this.items.length;
    },
    sortData() {
      this.items = _.orderBy(this.items, ['pl'],['desc']);
    }

  },
  sockets: {
    NEW_TRADER: function(data) {
      this.items.unshift(data);
      this.statCalculate();
    },
    UPDATE_RESULT: function(data) {
      this.items.forEach((item, index) => {
        if (item._id == data._id) {
          this.$set(this.items, index, data);
        }
      });
      this.statCalculate();
    },
    DELETE_RESULT: function(data) {
      this.items.forEach((item, index) => {
        if (item._id == data._id) {
          this.$delete(this.items, index);
        }
      });
      this.statCalculate();
    }
  }
};
</script>

<style scoped>
.nodata {
  text-align: center;
  width: 100%;
  float: left;
  padding-top: 10px;
  min-height: 50px;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.header {
  width: 100%;
}
.datetime {
  color: white;
  font-family: "Roboto", "Roboto Condensed", sans-serif;
  font-weight: bold;
  font-size: 16px;
  margin: 15px;
}

.postInput input[type="text"] {
  margin-right: 15px;
  height: 40px;
  width: 100%;
  border-radius: 20px;
  border: 0px;
  padding-left: 21px;
  background-color: #333b47 !important;
  color: white;
  font-size: 12px;
}

input[type="text"]::placeholder {
  /* Firefox, Chrome, Opera */
  color: white;
}

input[type="text"]:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: white;
}

input[type="text"]::-ms-input-placeholder {
  /* Microsoft Edge */
  color: white;
}
</style>
